module.exports = __webpack_public_path__ + "202419:4ba491f0bd9615732354/img/tmm-web-desk.360e8e2.webp";